import { DICTIONARY } from "../../dictionary";
import styles from "./message-kinds.module.scss";

// TODO <Text /> from core-ui

export const ServiceMessageNew = () => (
  <div
    className={styles["unread-notification"]}
    data-test-id="service-message-new-notification"
  >
    {DICTIONARY.UNREAD_MESSAGE_NOTIFICATION}
  </div>
);
